import {
  validateEmail, validatePasswordRedemptionAuth,
  validateFieldForRequired
} from 'libs/validator';

export const USER_INFO_KEYS = {
  EMAIL: 'email',
  PASSWORD: 'password',
  ACTIVATION_CODE: 'activationCode',
  FIRST_NAME: 'given_name',
  LAST_NAME: 'family_name',
  ACCESS_TOKEN: 'accessToken'
};

export const ERROR_INFO_KEYS = {
  AUTH_FORM: 'authForm'
};

export const AUTH_FORM_LOGIN_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [
    USER_INFO_KEYS.EMAIL, USER_INFO_KEYS.PASSWORD, USER_INFO_KEYS.ACTIVATION_CODE
  ]
};

export const AUTH_FORM_SIGNUP_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [
    USER_INFO_KEYS.EMAIL, USER_INFO_KEYS.PASSWORD, USER_INFO_KEYS.ACTIVATION_CODE,
    USER_INFO_KEYS.FIRST_NAME, USER_INFO_KEYS.LAST_NAME
  ]
};

export const GOOGLE_AUTH_CONTINUE_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [
    USER_INFO_KEYS.ACTIVATION_CODE
  ]
};

export function checkErrors(errorFields = [], userInfo = {}) {
  const errors = {};

  if (errorFields.indexOf(USER_INFO_KEYS.FIRST_NAME) !== -1) {
    const firstNameError = validateFieldForRequired(userInfo[USER_INFO_KEYS.FIRST_NAME]);
    if (firstNameError) {
      errors[USER_INFO_KEYS.FIRST_NAME] = firstNameError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.LAST_NAME) !== -1) {
    const lastNameError = validateFieldForRequired(userInfo[USER_INFO_KEYS.LAST_NAME]);
    if (lastNameError) {
      errors[USER_INFO_KEYS.LAST_NAME] = lastNameError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.EMAIL) !== -1) {
    const emailError = validateEmail(userInfo[USER_INFO_KEYS.EMAIL]);
    if (emailError) {
      errors[USER_INFO_KEYS.EMAIL] = emailError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.PASSWORD) !== -1) {
    const passwordError = validatePasswordRedemptionAuth(userInfo[USER_INFO_KEYS.PASSWORD]);
    if (passwordError) {
      errors[USER_INFO_KEYS.PASSWORD] = passwordError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.ACTIVATION_CODE) !== -1) {
    const activationCodeError = validateFieldForRequired(userInfo[USER_INFO_KEYS.ACTIVATION_CODE]);
    if (activationCodeError) {
      errors[USER_INFO_KEYS.ACTIVATION_CODE] = activationCodeError;
    }
  }

  return errors;
}

export default {
  USER_INFO_KEYS,
  ERROR_INFO_KEYS
};



// WEBPACK FOOTER //
// ./src/views/ActivatePartner/config.js